

export const deleteCookie = (name:string)=>{
   Office.context.roamingSettings.remove(name)
   Office.context.roamingSettings.saveAsync()
}



